module.exports = __webpack_public_path__ + "static/media/white-ico-alert-modal.974a1002.svg";